import { useARC } from "providers/ARC/ARCContext";
import { isHttpSecure } from "lib/utils/utils";

/**
 * Returns whether the current ARC connection should use HTTPS/WSS.
 * Reads isSecure from selectedARC (set by FleetARCProvider for fleet connections,
 * or derived from window.location.protocol for direct ARC connections).
 * Falls back to isHttpSecure() when used outside an ARCContext.
 */
const useIsHttpSecure = (): boolean => {
    const arc = useARC();
    return arc?.selectedARC?.isSecure ?? isHttpSecure();
};

export default useIsHttpSecure;
